import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function markThreadMessageAsOpenFailure(draft: Draft<IInterventionData>) {
  draft.markThreadMessageAsOpen.config.isLoading = false;
}

export default markThreadMessageAsOpenFailure;
